/* eslint-disable no-empty-pattern */
import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  getReportsRequest: ['page', 'page_size', 'sort', 'nextPage', 'search'],
  getReportsSuccess: ['list'],

  getReportsFetchingReset: null,
  getReportsReset: null,

  getReportIdRequest: ['id'],
  getReportIdSuccess: ['focusRow'],
  getReportIdReset: null,

  deleteReportRequest: ['id'],
  deleteReportSuccess: ['deleteReportResult'],
  deleteReportReset: null,
})

export const ReportAdminReduxTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,

  page: 1,
  page_size: 15,

  deleteReportResult: null,
  deleteReportFetching: false,

  idFetching: false,

  focusRow: null,
})

/* ------------- Selectors ------------- */

export const reportsSelectors = {
  reports: state => state.reportAdmin,
}
//export const getState = state => state.reportHelpAdmin

/* ------------- Reducers ------------- */
export const getReportsRequest = (state, {page, page_size, sort, nextPage, search}) => {
  const newState = {
    fetching: true,
  }
  page && (newState.page = page)
  page_size && (newState.page_size = page_size)
  return state.merge(newState)
}
export const getReportsSuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}

export const getReportsFetchingReset = state => {
  return state.merge({fetching: false, idFetching: false, deleteReportFetching: false})
}
export const getReportsReset = state => {
  return state.merge({
    list: null,
    fetching: false,

    page: 1,
    page_size: 15,

    deleteReportResult: null,
    deleteReportFetching: false,

    idFetching: false,

    focusRow: null,
  })
}

export const getReportIdRequest = (state, {id}) => {
  return state.merge({idFetching: true})
}
export const getReportIdSuccess = (state, {focusRow}) => {
  return state.merge({idFetching: false, focusRow})
}
export const getReportIdReset = state => {
  return state.merge({focusRow: null})
}

export const deleteReportRequest = (state, {id, data}) => {
  return state.merge({deleteReportFetching: true})
}
export const deleteReportSuccess = (state, {deleteReportResult}) => {
  return state.merge({
    list: {
      ...state.list,
      results: [...state.list.results.filter(ticket => ticket.id !== deleteReportResult)],
    },
    deleteReportFetching: false,
  })
}
export const deleteReportReset = (state, {}) => {
  return state.merge({deleteReportFetching: false, deleteReportResult: null})
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_REPORTS_REQUEST]: getReportsRequest,
  [Types.GET_REPORTS_SUCCESS]: getReportsSuccess,

  [Types.GET_REPORTS_FETCHING_RESET]: getReportsFetchingReset,
  [Types.GET_REPORTS_RESET]: getReportsReset,

  [Types.GET_REPORT_ID_REQUEST]: getReportIdRequest,
  [Types.GET_REPORT_ID_SUCCESS]: getReportIdSuccess,
  [Types.GET_REPORT_ID_RESET]: getReportIdReset,

  [Types.DELETE_REPORT_REQUEST]: deleteReportRequest,
  [Types.DELETE_REPORT_SUCCESS]: deleteReportSuccess,
  [Types.DELETE_REPORT_RESET]: deleteReportReset,
})
